import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

import { Link } from "react-router-dom";

import Logo from "../assets/logo-prev.png";

import "../styles/Header.css";

const Header = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsScrolled(window.scrollY > 50);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const navItems = [
        { href: "/", label: "Início" },
        { href: "/empresa", label: "Empresa" },
        { href: "/produtos", label: "Produtos" },
        { href: "/contato", label: "Contato" },
    ];

    const scrollToSection = (e, href) => {
        // use apenas para âncoras
        e.preventDefault();
        const el = document.querySelector(href);
        el?.scrollIntoView({ behavior: "smooth" });
        setIsMenuOpen(false);
    };

    const renderNavItem = (item, isMobile = false) => {
        const isRoute = item.href.startsWith("/");
        if (isRoute) {
            // Link do React Router para rotas
            return (
                <Link
                    key={item.href}
                    to={item.href}
                    className="nav-link"
                    onClick={() => isMobile && setIsMenuOpen(false)}
                >
                    {item.label}
                </Link>
            );
        }
        // Âncoras na mesma página
        return (
            <a
                key={item.href}
                href={item.href}
                className="nav-link"
                onClick={(e) => scrollToSection(e, item.href)}
            >
                {item.label}
            </a>
        );
    };

    return (
        <header className={`header ${isScrolled ? "scrolled" : ""}`}>
            <nav className="nav-container">
                {/* Logo */}
                <div className="logo">
                    <img src={Logo} alt="Ros Dormentes Logo" className="logo-image" />
                </div>

                {/* Navegação Desktop */}
                <div className="nav-desktop">
                    {navItems.map((item) => renderNavItem(item))}
                </div>

                {/* Botão Orçamento Desktop (âncora) */}
                <div className="btn-desktop">
                    <a
                        href="#contato"
                        className="btn-primary"
                        onClick={(e) => scrollToSection(e, "#contato")}
                    >
                        Orçamento
                    </a>
                </div>

                {/* Botão Mobile */}
                <button
                    className="menu-button"
                    onClick={() => setIsMenuOpen((o) => !o)}
                >
                    {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </nav>

            {/* Menu Mobile */}
            {isMenuOpen && (
                <div className="mobile-menu">
                    <div className="mobile-menu-content">
                        {navItems.map((item) => renderNavItem(item, true))}
                        <a
                            href="#contato"
                            className="btn-primary"
                            onClick={(e) => scrollToSection(e, "#contato")}
                        >
                            Solicitar Orçamento
                        </a>
                    </div>
                </div>
            )}
        </header>
    );
};

export default Header;